import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';

interface VerifyState {
    holderPublicKey: string;
    signerPublicKey: string;
    presentation: string;
    verified: string;
    publicKeyEncoding: string;
    signerPublicKeyEncoding: string;
}

const initialState: VerifyState = {
    holderPublicKey: '938ec3f412be512d80b053a02f544a6facebd85f1eea23d7231a5b0278244f8f',
    signerPublicKey: '8b77d43d90cde6652f71387d4a67256bd0fe40a9f78d993a987c1732db178eac',
    presentation: '',
    verified: '',
    publicKeyEncoding: 'Hex',
    signerPublicKeyEncoding: 'Hex'
};

export const verifySlice = createSlice({
    name: 'present',
    initialState,
    reducers: {
        setHolderPublicKey: (state, action: PayloadAction<string>) => {
            state.holderPublicKey = action.payload;
        },
        setSignerPublicKey: (state, action: PayloadAction<string>) => {
            state.signerPublicKey = action.payload;
        },
        setPresentation: (state, action: PayloadAction<string>) => {
            state.presentation = action.payload;
        },
        setVerified: (state, action: PayloadAction<string>) => {
            state.verified = action.payload;
        },
        setPublicKeyEncoding: (state, action: PayloadAction<string>) => {
            state.publicKeyEncoding = action.payload;
        },
        setSignerPublicKeyEncoding: (state, action: PayloadAction<string>) => {
            state.signerPublicKeyEncoding = action.payload;
        }
    }
});

export const {
    setHolderPublicKey,
    setPresentation,
    setSignerPublicKey,
    setVerified,
    setPublicKeyEncoding,
    setSignerPublicKeyEncoding
} = verifySlice.actions;

export const _holderPublicKey = (state: RootState) => state.verify.holderPublicKey;
export const _signerPublicKey = (state: RootState) => state.verify.signerPublicKey;
export const _presentation = (state: RootState) => state.verify.presentation;
export const _verified = (state: RootState) => state.verify.verified;
export const _publicKeyEncoding = (state: RootState) => state.verify.publicKeyEncoding;
export const _signerPublicKeyEncoding = (state: RootState) => state.verify.signerPublicKeyEncoding;

export default verifySlice.reducer;
